import React , { useRef, useEffect , useState} from 'react';

const Nav = () => {

    const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const spanElement = document.createElement('span');
      spanElement.className = 'menu-trigger';
      spanElement.innerHTML = '<i class="fal fa-angle-down"></i>';
      containerRef.current.appendChild(spanElement);
    }
  }, []);

  const [menuItems, setMenuItems] = useState([
    {
        label: 'Solutions',
        link: '#',
        class: 'current',
        submenu: [
          { label: 'Generative AI', link: '/generative-ai' },
          { label: 'App Idea Booster', link: '/a-idea-booster', target: '_blank'},
          { label: 'App Idea to Product', link: '/idea-to-product', target: '_blank'},
          { label: 'Plug and Play Call Center Service ', link: '/plug-and-play-call-center-service', target: '_blank'},
          { label: 'Client Success Service', link: '/client-success'},
          { label: 'IT Support', link: '/it_support'},
          { label: 'Mobile App & Software Development', link: '/mobile-software_development'},
          { label: 'Staffing Solutions', link: '/staffing-support-service'},
          { label: 'Comprehensive Website Design', link: '/comprehensive-website-design'},
          { label: 'Knowledge Process Outsourcing', link: '/knowledge-process-outsourcing'},
          { label: 'B2B Lead Generation', link: '/b2b-lead-generation-expert'},         
        ],
        submenuOpen: false, 
    },
    {
        label: 'Products',
        link: '/products',
        
    },
    {
      label: 'About Us',
      link: '#',
      submenu: [
        { label: 'Our Company', link: '/ourcompany' },
        { label: 'Management Team ', link: '/mteam' },
        { label: 'Press Release', link: '/pressrelease' },
        { label: 'Careers', link: '/careers' },
        
      ],
    },
    {
        label: 'Insights',
        link: '#',
        submenu: [
          { label: 'Blog', link: '/blog'},
          { label: 'Case Studies', link: '/casestudy' },
          { label: 'Free Downloads', link: '/freedownload' },
        ],
        submenuOpen: false, 
    },
    {
        label: 'Contact Us',
        link: '/contactus',
        
    },


  
    // Add more menu items as needed
  ]);
  useEffect(() => {
    setMenuItems((prevMenuItems) =>
      prevMenuItems.map((item) =>
        item.submenu && item.submenu.length > 0
          ? { ...item, hasSubmenu: true }
          : item
      )
    );
  }, []);

const handleSubmenuToggle = (index) => {
    setMenuItems((prevMenuItems) => {
      const newMenuItems = [...prevMenuItems];
      newMenuItems[index].submenuOpen = !newMenuItems[index].submenuOpen;
      return newMenuItems;
    });
  };

    return (
        
        <ul className="primary-menu light">
            {menuItems.map((item, index) => (
          <li key={index}>

            <a className='' href={item.link}>
              {item.label}
            </a>

            {item.submenu && (
              <span
                className={`menu-trigger ${item.submenuOpen ? 'open' : ' '}`}
                onClick={() => handleSubmenuToggle(index)}
              >
            
                <i 
                className={`submenu-icon ${item.submenuOpen ? 'fal fa-angle-up' : 'fal fa-angle-down'}`}>
              </i>
              </span>
            )}
            {item.submenu && (
              <ul className={`submenu ${item.submenuOpen ? 'open' : ''}`}
              
              >
                {item.submenu.map((subitem, subindex) => (
                   <li key={subindex} >
                    <a href={subitem.link}>{subitem.label}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}

    </ul>

    )
}
export default Nav;
